import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state) {
  return {
    ...state,
    isLoading: false,
  }
}
fulfilled.chain = () => actions.versetzungsplan.readVersetzungsplanTermine()

export function rejected(state) {
  return {
    ...state,
    isLoading: false,
  }
}

export async function action(payload) {
  try {
    return await Api.deleteTermin(payload.terminId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
